<template>
    <div class="w-full flex flex-column gap-2 mb-3">
        <span class="text-600 text-sm">{{ content[lang].from }}:</span>
        <div v-if="wallets || !loading" class="p-inputgroup w-full flex flex-column gap-2">
            <Select v-model="getWallet" :options="getWalletList" :disabled="!readyToSwap"
                option-label="get" class='w-full border-2 border-round-xl' size="large" :placeholder="content[lang].from">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center h-full py-2 text-sm">
                        {{ slotProps.value.name }} <span class="font-medium ml-1">{{ getFormatAmount(slotProps.value.balance, 'usdt') }}</span>
                    </div>
                    <span v-else class="flex align-items-center h-full py-2">
                        <div class="text-sm">{{ slotProps.placeholder }}</div>
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center w-7rem py-1 text-sm">
                        {{ slotProps.option.name }} <span class="font-medium ml-1">{{ getFormatAmount(slotProps.option.balance, 'usdt') }}</span>
                    </div>
                </template>
            </Select>

            <Select v-if="getWallet && getWallet.account_details && getWallet.account_details.length > 0" 
                v-model="fromAccount" :options="getWallet.account_details" :disabled="!readyToSwap"
                option-label="name" class='w-full border-2 border-round-xl' size="large" :placeholder="content[lang].to">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center h-full py-2 text-sm">
                        <AvatarGroup v-if="slotProps.value && slotProps.value.currency" :max="2" class="gap-1">
                            <Avatar :image="getCurImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                            <Avatar v-if="slotProps.value.network" :image="getNetworkImage(slotProps.value.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                        </AvatarGroup>
                        <span class="font-medium ml-1">{{ getFormatAmount(slotProps.value.balance, slotProps.value.currency) }}</span>
                    </div>
                    <span v-else class="flex align-items-center h-full py-2">
                        <div class="text-sm">{{ slotProps.placeholder }} </div>
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center w-7rem py-1 text-sm">
                        <AvatarGroup v-if="slotProps.option && slotProps.option.currency" :max="2" class="gap-1">
                            <Avatar :image="getCurImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                            <Avatar v-if="slotProps.option.network" :image="getNetworkImage(slotProps.option.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                        </AvatarGroup>
                        <span class="font-medium ml-1">{{ getFormatAmount(slotProps.option.balance, slotProps.option.currency) }}</span>
                    </div>
                </template>
            </Select>

        </div>
        <Skeleton v-else height="2rem" />
    </div>

    <div class="w-full flex flex-column gap-2 mb-3">
        <span class="text-600 text-sm">{{ content[lang].to }}:</span>
        <div v-if="wallets || !loading" class="p-inputgroup w-full flex flex-column gap-2">
            <Select v-model="sendWallet" :options="sendWalletList" :disabled="!readyToSwap"
                option-label="name" class='w-full border-2 border-round-xl' size="large" :placeholder="content[lang].to">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center h-full py-2 text-sm">
                        {{ slotProps.value.name }} <span class="font-medium ml-1">{{ getFormatAmount(slotProps.value.balance, 'usdt') }}</span>
                    </div>
                    <span v-else class="flex align-items-center h-full py-2">
                        <div class="text-sm">{{ slotProps.placeholder }} </div>
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center w-7rem py-1 text-sm">
                        {{ slotProps.option.name }} <span class="font-medium ml-1">{{ getFormatAmount(slotProps.option.balance, 'usdt') }}</span>
                    </div>
                </template>
            </Select>

            <Select v-if="sendWallet && sendWallet.account_details && sendWallet.account_details.length > 0" 
                v-model="toAccount" :options="sendWallet.account_details" :disabled="!readyToSwap"
                option-label="name" class='w-full border-2 border-round-xl' size="large" :placeholder="content[lang].to">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center h-full py-2 text-sm uppercase">
                        <AvatarGroup v-if="slotProps.value && slotProps.value.currency" :max="2" class="gap-1">
                            <Avatar :image="getCurImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                            <Avatar v-if="slotProps.value.network" :image="getNetworkImage(slotProps.value.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                        </AvatarGroup>
                        <span class="font-medium ml-1">{{ getFormatAmount(slotProps.value.balance, slotProps.value.currency) }}</span>
                    </div>
                    <span v-else class="flex align-items-center h-full py-2">
                        <div class="text-sm">{{ slotProps.placeholder }} </div>
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center w-7rem py-1 text-sm uppercase">
                        <AvatarGroup v-if="slotProps.option && slotProps.option.currency" :max="2" class="gap-1">
                            <Avatar :image="getCurImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                            <Avatar v-if="slotProps.option.network" :image="getNetworkImage(slotProps.option.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                        </AvatarGroup>
                        <span class="font-medium ml-1">{{ getFormatAmount(slotProps.option.balance, slotProps.option.currency) }}</span>
                    </div>
                </template>
            </Select>

        </div>
        <Skeleton v-else height="2rem" />
    </div>

    <!-- <div class="w-full flex flex-column gap-2 mb-3">
        <span class="text-600 text-sm">{{ content[lang].currency }}:</span>
        <div class="w-full flex flex-row">
            <Select v-model="currency" :options="currencies" :disabled="!readyToSwap"
                option-label="name" class='w-full border-2 border-round-xl' size="large" :placeholder="content[lang].currency">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center h-full">
                        <Avatar :image="`/images/svg/currencies/${slotProps.value.code}.svg`"  shape="circle" class="mr-2 border-200 border-1"/>
                        <div class="text-sm">{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else class="flex align-items-center h-full py-2">
                        <div class="text-sm">{{ slotProps.placeholder }}</div>
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center w-7rem py-1">
                        <div class="text-sm">{{ slotProps.option.name }}</div>
                    </div>
                </template>
            </Select>
        </div>
    </div> -->

    <div class="w-full flex flex-column gap-2 mb-3">
        <span class="text-600 text-sm">{{ content[lang].amount }}:</span>
        <InputNumber :placeholder="content[lang].amount" v-model="amount" inputId="locale-us" size="large"
            class="flex w-full border-2 border-round-xl surface-border text-xl font-bold overflow-hidden amount_input"
            :disabled="!readyToSwap" 
            :min-fraction-digits="0" :max-fraction-digits="2" :min="minAmount" :max="maxAmount"/>
        <div class="text-xs flex flex-row justify-content-between"> 
            <span class="text-500"> {{ minAmount }} – {{ split_num(maxAmount) }} USDT </span>
            <span class="text-blue-500 cursor-pointer" @click="setMaxAmount(maxAmount)"> {{ content[lang].btnMax }} </span>
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import BigNumber from 'bignumber.js'
import Helper from '@/assets/js/Helper'
import Profile from '@/components/personal/profile/Index.vue' 
import { mapActions } from  'vuex'

export default {
	name: 'ExchangeWallet',
    props: {
        wallet_id: {
            type: Number,
            default: null
        },
        onClick: {
            type: Boolean,
            default: false
        },
    },
	data() {
		return {
            loading: false,
            isLoading: false,
            wallets: [],
            getWallet: null,
            getWalletList: [],
            sendWallet: null,
            sendWalletList: [],
            fromAccount: {},
            toAccount: {},
            currencies: [
                { name: 'USDT', code: 'usdt' },
            ],
            currency: { name: 'USDT', code: 'usdt' },
            // fromCurrencyCode: null,
            // toCurrencyCode: null,
            amount: 1,
            minAmount: 1,
            maxAmount: 0,

            content: {
                ru: {
                    from: 'Со счета',
                    to: 'На счет',
                    currency: 'Валюта',
                    amount: 'Сумма',
                    btnMax: 'Максимум',
                    errorTitle: 'Ошибка',
                    errorText: 'Не удалось получить данные о кошельках',
                    successTitle: 'Успешно',
                    successText: 'Перевод совершен',
                },
                en: {
                    from: 'From wallet',
                    to: 'To wallet',
                    currency: 'Currency',
                    amount: 'Amount',
                    btnMax: 'Max',
                    errorTitle: 'Error',
                    errorText: 'Failed to get wallets data',
                    successTitle: 'Success',
                    successText: 'Transfer completed',
                }
            }, 
		}
	},
    components: {
        Profile
    },
	watch: {
        wallets: function () {
            if(!this.wallets || !this.wallets.length || this.wallets.length <= 0) return
                
            let elList = []
            for (let i = 0; i < this.wallets.length; i++) {
                const balance = this.roundAmount(this.wallets[i].balance)
                let el = {
                    id:     this.wallets[i].id,
                    type:   this.wallets[i].ext_type,
                    balance: balance,
                    name:   this.getWalletNameByType(this.wallets[i].ext_type),
                    account_details: this.wallets[i]?.account_details || []
                }
                elList.push(el)
            }
            this.getWalletList = this.getAmountedList(elList)
            this.getWallet = (this.getWalletList && this.getWalletList.length > 0) ? this.getWalletList[0] : null
            if(this.getWallet) {
                this.fromAccount = (this.getWallet.account_details && this.getWallet.account_details.length > 0) ? this.getWallet.account_details[0] : null
                this.fromCurrencyCode = this.fromAccount?.currency || null
            }
            this.sendWalletList = elList
        },
        getWallet: function (val) {
            if(!val || !val.type || !val.balance) return

            this.minAmount = 1
            
            let elList = []
            for (let i = 0; i < this.wallets.length; i++) {
                let el = {
                    id:     this.wallets[i].id,
                    type:   this.wallets[i].ext_type,
                    balance: this.wallets[i].balance,
                    name:   this.getWalletNameByType(this.wallets[i].ext_type),
                    account_details: this.wallets[i]?.account_details || []
                }
                if(el.type != val.type) elList.push(el)
            }
            this.sendWalletList = elList
            this.sendWallet = elList[0]
            if(this.sendWallet) {
                this.toAccount = (this.sendWallet.account_details && this.sendWallet.account_details.length > 0) ? this.sendWallet.account_details[0] : null
                this.toCurrencyCode = this.toAccount?.currency || null
            }
            if(this.getWallet && this.getWallet.account_details && this.getWallet.account_details.length > 0) {
                this.fromAccount = this.getWallet.account_details[0]
                this.fromCurrencyCode = this.fromAccount?.currency || null

                this.maxAmount = this.roundAmount(this.fromAccount.balance)
                const minAmount = new BigNumber(this.minAmount)
                const maxAmount = new BigNumber(this.maxAmount)
                const bAmount = new BigNumber(this.amount)
                if(bAmount.isNaN()) this.amount = 0
                if(bAmount.isGreaterThanOrEqualTo(maxAmount)) this.amount = this.maxAmount
                if(bAmount.isLessThanOrEqualTo(minAmount)) this.amount = this.minAmount
            }
        },
        sendWallet: function (val) {
            if(!val || !val.type || !val.balance) return

            if(this.sendWallet && this.sendWallet.account_details && this.sendWallet.account_details.length > 0) {
                this.toAccount = this.sendWallet.account_details[0]
                this.toCurrencyCode = this.toAccount?.currency || null
            }
        },
        fromAccount: function(val) {
            this.fromCurrencyCode = val?.currency || null
            this.maxAmount = this.roundAmount(val.balance)
            const minAmount = new BigNumber(this.minAmount)
            const maxAmount = new BigNumber(this.maxAmount)
            const bAmount = new BigNumber(this.amount)
            if(bAmount.isNaN()) this.amount = 0
            if(bAmount.isGreaterThanOrEqualTo(maxAmount)) this.amount = this.maxAmount
            if(bAmount.isLessThanOrEqualTo(minAmount)) this.amount = this.minAmount
        },
        toAccount: function(val) {
            this.toCurrencyCode = val?.currency || null
        },
        onClick: function () {
            this.swap()
        },
        isLoading: function(that){
            this.$emit('loading', that)
        },
	},
	methods: {
        ...mapActions(['ActionGetAllWallets', 'ActionExchangeBalances']),
        getWalletNameByType(type) {
            return this.helper.getWalletNameByType(type, this.lang)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        getFormatAmount(value, currency, decimals = 2){
            return this.helper.format_amount(value, currency, decimals)
        },
        setMaxAmount(val) {
            this.amount = val
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        getNetworkImage(network) {
            if(!network) return null
           return this.helper.GetNetworkImage(network)
        },
        getAmountedList(elList) {
            if(!elList || !elList.length || elList.length <= 0) return []
            const min = new BigNumber(1)
            let returnList = []
            for(let i = 0; i < elList.length; i++) {
                const bBalance = new BigNumber(elList[i].balance)
                if(bBalance.isNaN() || bBalance.isGreaterThanOrEqualTo(min)) returnList.push(elList[i])
            }
            return returnList
        },
        roundAmount(val){
            const bAmount = new BigNumber(val)
            if(bAmount.isNaN()) return 0
            const floored = bAmount.decimalPlaces(2, BigNumber.ROUND_FLOOR)
            const decimals = floored.decimalPlaces()
            if(decimals >= 2) return floored.toFixed(2)
            else if(decimals == 1)return floored.toFixed(1)
            else return floored.toFixed(0)
        },
        async getWallets(){
            this.isLoading = true
            try {
                const resWallets = await this.ActionGetAllWallets().then(res=>res)
                if(resWallets.result && resWallets.data && resWallets.data.wallets) this.wallets = resWallets.data.wallets
                else {
                    this.wallets = []
                    this.showMess('error', this.content[this.lang].error, this.content[this.lang].error_text)
                }
            } catch (error) { console.log(error) }
            this.isLoading = false
        },
        async swap(){
            this.isLoading = true 
            let transfer = {}

            try {
                const data = {
                    from_wallet_id:     this.getWallet.id,
                    to_wallet_id:       this.sendWallet.id,
                    amount:             this.amount,
                    from_currency_code: this.fromCurrencyCode,
                    to_currency_code:   this.toCurrencyCode
                }
                transfer = await this.ActionExchangeBalances(data).then(res=>res)
                if(transfer.result && transfer.data) {
                    this.showMess('success', this.content[this.lang].successTitle, this.content[this.lang].successText)
                    this.$emit('close', true)
                } else {
                    if(transfer.errors) {
                        try {
                            for (let i = 0; i < transfer.errors.length; i++) {
                                this.showMess('error', this.content[this.lang].errorTitle, transfer.errors[i])
                            }
                        } catch(e) {
                            console.log('error', e)
                        }
                    } else {
                        this.showMess('error', this.content[this.lang].errorTitle, this.content[this.lang].errorText)
                    }
                }
                this.isLoading = false
            } catch(e) {
                console.log('error', e)
                const msg = (e.message) ? e.message : this.content[this.lang].errorText
                this.showMess('error', this.content[this.lang].errorTitle, msg)
                this.isLoading = false
            }

            return
        },
        split_num(num){
            const bNum = new BigNumber(num)
            if(bNum.isNaN()) return 0
            if(bNum.isLessThanOrEqualTo(0)) return 0
            return this.roundAmount(num)
        },
        getCurrencyList(){
            const objList = this.$store.state.payment.currencies
            if(!objList)return
            let currencies = []
            for(const [k,v] of Object.entries(objList)){
                currencies.push({
                    code: v.code,
                    name: k.toUpperCase(),
                    image: v.image
                })
            }
            this.currencies = currencies
        },
	},
    computed : {
        isAuth: function () { return this.$store.getters.isAuthenticated },
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        user_name: function () { return this.$store.getters.StateUserName },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        readyToSwap: function (){
            if(!this.getWalletList || this.getWalletList.length<=0) return false
            if(!this.sendWalletList || this.sendWalletList.length<=0) return false
            return true
        }
    },
	beforeCreate() {
        this.helper = new Helper()
    },
	async mounted() {
        this.connect = new Connect()
        this.getWallets().then(res => res)
        this.getCurrencyList()
	}
}
</script>